<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="接口名称">
                <el-input style='width: 200px;' v-model="queryForm.apiName"></el-input>
            </el-form-item>
            <el-form-item label="门店id">
                <GridSelectLi style="width: 200px" title="选择门店" labelName="storeName" labelValue="id"
                              :value="queryForm.storeId" :limit="1" size="small"
                              @getValue="getSearchValueStoreId"
                              :columns="STORE_code" :searchs="STORE_search" dataListUrl="/shop/store/findList" entityBeanName="shopStore" queryEntityUrl="/shop/store/get">
                </GridSelectLi>
            </el-form-item>
            <el-form-item label="收银渠道">
                <el-select v-model="queryForm.channelType" placeholder="请选择" style="width: 200px">
                    <el-option
                        v-for="item in channelTypeList"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStorePayapiList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addShopStorePayapi"
                    >新建
                    </el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopStorePayapi(null)"
                    >修改
                    </el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopStorePayapi(null)"
                    >删除
                    </el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                      <Icon color="#606266">
                        <Search />
                      </Icon>
                    </span>
                    <span
                        title="下载模板"
                        class="icon-box"
                        @click="importTemplate"
                    >
                      <Icon color="#606266">
                        <ArrowDown />
                      </Icon>
                    </span>
                    <span
                        class="icon-box"
                        title="导入数据"
                        @click="isImport"
                    >
                      <Icon color="#606266">
                        <ArrowExportUp24Regular />
                      </Icon>
                    </span>
                    <span
                        title="导出数据"
                        class="icon-box"
                        @click="exportShopStorePayapiList"
                    >
                      <Icon color="#606266">
                        <ArrowDownload24Regular />
                      </Icon>
                    </span>
                    <span
                        class="icon-box"
                        @click="refreshShopStorePayapiList"
                    >
                      <Icon color="#606266">
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopStorePayapiList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="apiName"
                    label="接口名称"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="storeId"
                    label="门店id"
                    width="180"
                >
                    <template scope="scope">
                        <div v-if="scope.row.store">{{scope.row.store.storeName}}</div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="开通状态"
                    width="180"
                >
                    <template scope="scope">
                        <div>收银机支付：{{scope.row.openCashRegister == 1 ? '已开通' : '未开通'}}</div>
                        <div>第四方支付：{{scope.row.openFourthPay == 1 ? '已开通' : '未开通'}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="channelType"
                    label="收银渠道"
                    width="180"
                >
                    <template scope="scope">
                        {{returnValue(scope.row.channelType)}}
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="subAccount"
                    label="支付平台子账号"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="defaultUserId"
                    label="默认用户ID"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="appId"
                    label="支付接口ID"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="appSecret"
                    label="支付接口密钥"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="wxPublicAppId"
                    label="微信公众号APPID"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="wxAppAppId"
                    label="微信小程序APPID"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="aliLifeAppId"
                    label="微信生活号APPID"
                    width="180"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="aliAppAppId"
                    label="信微小程序APPID"
                    width="180"
                ></el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkShopStorePayapi(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editShopStorePayapi(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteShopStorePayapi(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopStorePayapiStates[shopStorePayapiState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="shopStorePayapi"
                        ref="shopStorePayapiForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="接口名称"
                            prop="apiName"
                        >
                            <el-input
                                size="small"
                                style="width: 200px;"
                                v-model="shopStorePayapi.apiName"
                                :disabled="shopStorePayapiState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="选择门店"
                            prop="storeId"
                        >
                            <GridSelectLi
                                style="width: 200px"
                                title="选择门店"
                                labelName="storeName"
                                labelValue="id"
                                :value="shopStorePayapi.storeId"
                                :limit="1"
                                size="small"
                                placeholder="请选择门店"
                                @getValue="getSeachValuebrandId1"
                                :columns="STORE_code"
                                :searchs="STORE_search"
                                dataListUrl="/shop/store/findList"
                                entityBeanName="shopStore"
                                queryEntityUrl="/shop/store/get"
                                :disabled="shopStorePayapiState == 'check'"
                            >
                            </GridSelectLi>
                        </el-form-item>
                        <el-form-item label="收银渠道" prop="channelType">
                            <el-select v-model="shopStorePayapi.channelType" :disabled="shopStorePayapiState == 'check'" placeholder="请选择" style="width: 200px">
                                <el-option
                                    v-for="item in channelTypeList"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
<!--                        <el-form-item-->
<!--                            label="子商户号"-->
<!--                            prop="subAccount"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="shopStorePayapi.subAccount"-->
<!--                                :disabled="shopStorePayapiState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item
                            label="默认用户ID"
                            prop="defaultUserId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px"-->
<!--                                v-model="shopStorePayapi.defaultUserId"-->
<!--                                :disabled="shopStorePayapiState == 'check'"-->
<!--                            ></el-input>-->
                            <GridSelectLi style="width: 200px;" labelName="userName" title="选择用户" :disabled="shopStorePayapiState == 'check'"
                                         labelValue="id" :value="shopStorePayapi.defaultUserId" :limit='1' size='small' placeholder='请选择用户'
                                         @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                            </GridSelectLi>
                        </el-form-item>
<!--                        <el-form-item-->
<!--                            label="支付接口ID"-->
<!--                            prop="appId"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px"-->
<!--                                v-model="shopStorePayapi.appId"-->
<!--                                :disabled="shopStorePayapiState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            label="支付接口密钥"-->
<!--                            prop="appSecret"-->
<!--                        >-->
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 200px"-->
<!--                                v-model="shopStorePayapi.appSecret"-->
<!--                                :disabled="shopStorePayapiState == 'check'"-->
<!--                            ></el-input>-->
<!--                        </el-form-item>-->
                        <el-form-item
                            label="微信公众号APPID"
                            prop="wxPublicAppId"
                        >
                            <el-input
                                size="small"
                                style="width: 200px;"
                                v-model="shopStorePayapi.wxPublicAppId"
                                :disabled="shopStorePayapiState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="微信小程序APPID"
                            prop="wxAppAppId"
                        >
                            <el-input
                                size="small"
                                style="width: 200px;"
                                v-model="shopStorePayapi.wxAppAppId"
                                :disabled="shopStorePayapiState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="微信生活号APPID"
                            prop="aliLifeAppId"
                        >
                            <el-input
                                size="small"
                                style="width: 200px;"
                                v-model="shopStorePayapi.aliLifeAppId"
                                :disabled="shopStorePayapiState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="信微小程序APPID"
                            prop="aliAppAppId"
                        >
                            <el-input
                                size="small"
                                style="width: 200px;"
                                v-model="shopStorePayapi.aliAppAppId"
                                :disabled="shopStorePayapiState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="开通收银机支付"
                            prop="openCashRegister"
                        >
                            <el-select v-model='shopStorePayapi.openCashRegister' :disabled="shopStorePayapiState == 'check'" style="width: 200px" size='small'>
                                <el-option v-for='(item, index) in yesNoEnumList' :key='index' :label='item.value' :value='item.key'>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="开通四方支付"
                            prop="openFourthPay"
                        >
                            <el-select v-model='shopStorePayapi.openFourthPay' :disabled="shopStorePayapiState == 'check'" style="width: 200px" size='small'>
                                <el-option v-for='(item, index) in yesNoEnumList' :key='index' :label='item.value' :value='item.key'>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="shopStorePayapiState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { PRODUCT1, PRODUCT_SEARCH1, STORE, STORE_SEARCH, USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectLi
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopStorePayapiList();
                this.getShopStorePayapiList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopStorePayapiList();
                this.getShopStorePayapiList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            STORE_code: STORE,
            STORE_search: STORE_SEARCH,
            yesNoEnumList: [],
            USER_code: USER,
            USER_search: USER_SEARCH,
            queryForm: {
                id: '', //
                apiName: '', //接口名称
                storeId: '', //门店id
                subAccount: '', //支付平台子账号
                defaultUserId: '', //默认用户ID
                appId: '', //支付接口ID
                appSecret: '', //支付接口密钥
                wxPublicAppId: '', //微信公众号APPID
                wxAppAppId: '', //微信小程序APPID
                aliLifeAppId: '', //微信生活号APPID
                aliAppAppId: '', //信微小程序APPID
                openCashRegister: '', //开通收银机支付
                openFourthPay: '', //开通四方支付
                channelType: '', // 收银渠道
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopStorePayapiState: 'add',
            shopStorePayapiStates: {
                add: '新建门店接口',
                check: '查看门店接口',
                edit: '修改门店接口'
            },

            multipleSelection: [],
            shopStorePayapiList: [],
            shopStorePayapi: {
                id: '', //
                apiName: '', //接口名称
                storeId: '', //门店id
                subAccount: '', //支付平台子账号
                defaultUserId: '', //默认用户ID
                appId: '', //支付接口ID
                appSecret: '', //支付接口密钥
                wxPublicAppId: '', //微信公众号APPID
                wxAppAppId: '', //微信小程序APPID
                aliLifeAppId: '', //微信生活号APPID
                aliAppAppId: '', //信微小程序APPID
                openCashRegister: '', //开通收银机支付
                openFourthPay: '', //开通四方支付
                channelType: '', // 收银渠道
            },
            btnLoading: false,

            rules: {
                apiName: [{ required: true, message: '接口名称不能为空', trigger: 'blur' }],
                storeId: [{ required: true, message: '门店id不能为空', trigger: 'blur' }],
                subAccount: [{ required: true, message: '支付平台子账号不能为空', trigger: 'blur' }],
                // defaultUserId: [{ required: true, message: '默认用户ID不能为空', trigger: 'blur' }],
                // appId: [{ required: true, message: '支付接口ID不能为空', trigger: 'blur' }],
                // appSecret: [{ required: true, message: '支付接口密钥不能为空', trigger: 'blur' }],
                // wxPublicAppId: [{ required: true, message: '微信公众号APPID不能为空', trigger: 'blur' }],
                // wxAppAppId: [{ required: true, message: '微信小程序APPID不能为空', trigger: 'blur' }],
                // aliLifeAppId: [{ required: true, message: '微信生活号APPID不能为空', trigger: 'blur' }],
                // aliAppAppId: [{ required: true, message: '信微小程序APPID不能为空', trigger: 'blur' }],
                openCashRegister: [{ required: true, message: '开通收银机支付不能为空', trigger: 'blur' }],
                openFourthPay: [{ required: true, message: '开通四方支付不能为空', trigger: 'blur' }],
                channelType: [{ required: true, message: '收银渠道不能为空', trigger: 'blur' }]
            },

            channelTypeList: [],
        };
    },
    created() {
        this.getShopStorePayapiList();
        this.getEnum();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        getValueUser(val){
            this.shopStorePayapi.defaultUserId = val;
        },
        getSearchValueStoreId(val){
            this.queryForm.storeId = val;
        },
        getValueStoreId(val){
            this.shopStorePayapi.defaultUserId = val;
        },
        resetShopStorePayapiList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopStorePayapiList = [];
        },
        resetDialog() {
            this.shopStorePayapiState = 'add';
            this.showDialog = false;
            this.queryForm = {
                id: '', //
                apiName: '', //接口名称
                storeId: '', //门店id
                subAccount: '', //支付平台子账号
                defaultUserId: '', //默认用户ID
                appId: '', //支付接口ID
                appSecret: '', //支付接口密钥
                wxPublicAppId: '', //微信公众号APPID
                wxAppAppId: '', //微信小程序APPID
                aliLifeAppId: '', //微信生活号APPID
                aliAppAppId: '', //信微小程序APPID
                openCashRegister: '', //开通收银机支付
                openFourthPay: '', //开通四方支付
                channelType: '', // 收银渠道
            };
            this.getShopStorePayapiList();
        },
        closeDialog() {
            this.showDialog = false;
            this.shopStorePayapi = {
                id: '', //
                apiName: '', //接口名称
                storeId: '', //门店id
                subAccount: '', //支付平台子账号
                defaultUserId: '', //默认用户ID
                appId: '', //支付接口ID
                appSecret: '', //支付接口密钥
                wxPublicAppId: '', //微信公众号APPID
                wxAppAppId: '', //微信小程序APPID
                aliLifeAppId: '', //微信生活号APPID
                aliAppAppId: '', //信微小程序APPID
                openCashRegister: '', //开通收银机支付
                openFourthPay: '', //开通四方支付
                channelType: '', // 收银渠道
            };
        },
        submitForm() {
            if (this.shopStorePayapiState == 'add') {
                this.$refs.shopStorePayapiForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/storepayapi/add`, { ...this.shopStorePayapi }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStorePayapiList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.shopStorePayapiState == 'edit') {
                this.$refs.shopStorePayapiForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        delete this.shopStorePayapi.store
                        delete this.shopStorePayapi.storeOrginfo
                        post(`/shop/storepayapi/edit`, { ...this.shopStorePayapi }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStorePayapiList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addShopStorePayapi() {
            this.showDialog = true;
            this.shopStorePayapiState = 'add';
        },
        checkShopStorePayapi(shopStorePayapiId) {
            console.log(shopStorePayapiId);
            this.currentShopStorePayapiId = shopStorePayapiId;

            this.getShopStorePayapiById();
            this.showDialog = true;
            this.shopStorePayapiState = 'check';
        },
        editShopStorePayapi(shopStorePayapiId) {
            console.log('shopStorePayapi', shopStorePayapiId);
            if (shopStorePayapiId) {
                this.currentShopStorePayapiId = shopStorePayapiId;
                this.getShopStorePayapiById();
            } else {
                this.shopStorePayapi = { ...this.shopStorePayapi, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopStorePayapiState = 'edit';
        },
        deleteShopStorePayapi(shopStorePayapiId) {
            let ids = '';
            if (shopStorePayapiId) {
                ids = shopStorePayapiId;
            } else {
                ids = this.multipleSelection.map((shopStorePayapi) => shopStorePayapi.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/storepayapi/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopStorePayapiList();
                            this.getShopStorePayapiList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshShopStorePayapiList() {
            this.resetShopStorePayapiList();
            this.getShopStorePayapiList();
        },
        getShopStorePayapiList(query = {}) {
            this.loading = true;
            get(`/shop/storepayapi/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopStorePayapiList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getShopStorePayapiById() {
            get(`/shop/storepayapi/get`, { id: this.currentShopStorePayapiId }).then((res) => {
                if (res.success) {
                    this.shopStorePayapi = { ...this.shopStorePayapi, ...res.shopStorePayapi };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopStorePayapiList() {
            //this.btnLoading = true;
            exprotExcel(`/shop/storepayapi/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/shop/storepayapi/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/storepayapi/importData`, formData);
            this.refreshShopStorePayapiList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopStorePayapiList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopStorePayapiList();
        },

        // 搜索门店
        getSeachValuebrandId1(value){
            this.shopStorePayapi.storeId = value
        },

        // 获取枚举
        getEnum(){
            get('/mpp/utils/getEnum', { enumType: 'yes_no' }).then((res) => {
                if (res.success) {
                    this.yesNoEnumList = res.enumList;
                }
            });
            get('/shop/utils/getEnum', { enumType: 'pay_channel_type' }).then((res) => {
                if (res.success) {
                    this.channelTypeList = res.enumList;
                }
            });
        },

        // 返回渠道
        returnValue(key){
            for (let i = 0; i < this.channelTypeList.length; i++) {
                if(this.channelTypeList[i].key == key){
                    return this.channelTypeList[i].value;
                }
            }
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>